import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";

export default function Intro1() {
  const navigate = useNavigate();
  const heroImages = ["/tech1.jpg", "/tech2.jpg", "/tech3.jpg"];
  const [currentImage, setCurrentImage] = useState(0);

  // Change background every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Preload images
  useEffect(() => {
    heroImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    // fixed navbar spacing
    <section className="relative w-full h-screen overflow-hidden bg-black pt-[90px]">

      {/* Background Images */}
      {heroImages.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Background ${index + 1}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-in-out ${
            index === currentImage ? "opacity-100 animate-zoomFloat" : "opacity-0"
          }`}
        />
      ))}

      {/* Overlay with black gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-transparent"></div>

      {/* Hero Content */}
      <div
        className="relative z-10 flex flex-col justify-center h-full 
        max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10 
        text-left animate-fade-up -mt-12"
      >
        <p className="text-sm uppercase tracking-widest text-gray-300 mb-3">
          — Leading IT Solutions
        </p>

        {/* Animated Heading */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-snug text-white mb-4">
          Best{" "}
          <span className="text-[#df2313]">
            <TypeAnimation
              sequence={[
                "IT Solution Agency",
                2500,
                "",
                800,
                "Software Experts",
                2500,
                "",
                800,
                "Development Partner",
                2500,
              ]}
              speed={50}
              deletionSpeed={30}
              repeat={Infinity}
              wrapper="span"
              cursor={true}
            />
          </span>{" "}
          For Your Business
        </h1>

        <p
          className="mt-3 text-md sm:text-lg text-gray-200 max-w-3xl leading-relaxed"
          style={{ textShadow: "1px 1px 12px rgba(0,0,0,0.5)" }}
        >
          At <strong>Codex Future Technologies</strong>, we create future-ready software
          solutions that scale your business seamlessly. From web and mobile apps to cloud
          integrations, we deliver speed, security, and innovation.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => navigate("/services")}
            className="px-8 py-3 bg-[#df2313] text-white font-medium rounded-full hover:scale-105 transition-all duration-300 shadow-xl"
          >
            Explore Services
          </button>

          <button
            onClick={() => navigate("/contact")}
            className="px-8 py-3 border border-white text-white rounded-full hover:bg-white hover:text-black transition-all duration-300"
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Layered Wave at Bottom */}
      <svg
        className="absolute bottom-0 left-0 w-full"
        viewBox="0 0 1440 320"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#ffffff"
          fillOpacity="0.7"
          d="M0,192L60,202.7C120,213,240,235,360,245.3C480,256,600,256,720,229.3C840,203,960,149,1080,144C1200,139,1320,181,1380,202.7L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
        ></path>
        <path
          fill="#ffffff"
          fillOpacity="0.5"
          d="M0,224L60,213.3C120,203,240,181,360,181.3C480,181,600,203,720,208C840,213,960,203,1080,176C1200,149,1320,107,1380,85.3L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
        ></path>
      </svg>
      
       
      {/* Animations */}
      <style>{`
        @keyframes zoomFloat {
          0% { transform: scale(1) translateY(0px); }
          50% { transform: scale(1.05) translateY(-8px); }
          100% { transform: scale(1.1) translateY(0px); }
        }
        .animate-zoomFloat {
          animation: zoomFloat 6s ease-in-out forwards;
        }

        @keyframes fade-up {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-up {
          animation: fade-up 1.5s ease-out forwards;
        }
      `}</style>
    </section>
  );
}
